import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_CARD_BRAND_DEF,
} from "./actionTypes"

import {
    getCardBrandDefListSuccess,
    cardBrandDefApiError
} from "./actions"

import {
    GetAllCardBrandDef,
} from "../../helpers/backend_helper/backend_helper"

function* onGetCardBrandDefList() {
  try {
    const response = yield call(GetAllCardBrandDef)
    yield put(getCardBrandDefListSuccess(response))
  } catch (error) {
    yield put(cardBrandDefApiError(error))
  }
}

function* cardBrandDefSaga() {
    yield takeEvery(GET_CARD_BRAND_DEF,onGetCardBrandDefList)
}

export default cardBrandDefSaga